import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {SnapshotTypeSearch} from "../PA.UIM.TPM/SnapshotTypeSearch";

const vUI_Snapshot_Parameter_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_SNAPSHOT_PARAM_ID:     {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'Wb Id',     columnResourceName: 'colwbId',      alignment: HorizAlignment.Left},  domainOptions: {} },
    PARAM_ID:    {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Id',        columnResourceName: 'colId',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PARAM_NAME:  {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Name',      columnResourceName: 'colName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    PARAM_TYPE:  {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Type',      columnResourceName: 'colType',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'wb Sales Org',
            columnResourceName: 'colSalesOrgId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESORG_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'SalesOrg Id', columnResourceName: 'colSalesOrgId', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Org',
            columnResourceName: 'colSALESORGNAME',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    CREATED_BY: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Created By',
            columnResourceName: 'colCreatedBy',
            alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const SnapshotParameterSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_SNAPSHOT_PARAM_ID',
        id_ui: 'PARAM_ID',
        name:  'PARAM_NAME'

    },

    searchProviderFields: vUI_Snapshot_Parameter_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Snapshot_Parameter_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    },

    // Filter with drop down in the Snapshot Search
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let searchRequestSubset: { where?: { [id: string]: any } } = {}
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                if(fieldName == "SALESORG_NAME") {
                   searchRequestSubset = {where: {WB_SALESORG_ID: {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}}}
                }
            }

            let results: any[] = undefined
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Snapshot_Parameter_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {

                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const SnapshotParameterSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "SnapshotParameterSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',   searchProviderFieldId:  'PARAM_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PARAM_NAME', renderOptions: {}},
        {profileFilterName: 'Sales Org', searchProviderFieldId: 'SALESORG_NAME', bMultiSelect: true, renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'PARAM_ID', 'PARAM_NAME', 'SALESORG_NAME', 'CREATED_BY', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: SnapshotParameterSearchProviderBasic,

    profileTreeIdDefault: "default",
    profileTrees: [],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SnapshotParameterSearch: ISearch = {
    searchName: "Find Snapshot Parameter",
    renderOptions: {ui5ResourceId: "SnapshotParameterSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SnapshotParameterSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("SnapshotParameterBO", "SnapshotParameter", SnapshotParameterSearch, "Snapshot Parameter Search")

export {SnapshotParameterSearch}